// Capture proof before OAuth/OTP replaces the anonymous session. The server
// verifies that identity; no browser-supplied guest ID authorizes a transfer.
export async function prepareGuestMediaHandoff(supabase, fetchImpl = fetch) {
  try {
    const { data } = await supabase.auth.getSession();
    if (data?.session?.user?.is_anonymous !== true) return;
    await fetchImpl('/api/upload/guest-handoff', { method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'prepare' }) });
  } catch {
    // Authentication remains available. Without valid proof, a later generation
    // gets an actionable re-upload error and cannot adopt somebody else's file.
  }
}

export function generationInputUrls(data) {
  const urls = [];
  for (const key of ['inputAssets', 'imageUrl', 'image_url', 'inputImageUrl', 'input_image_url', 'inputVideoUrl', 'input_video_url', 'inputAudioUrl', 'input_audio_url']) {
    const values = Array.isArray(data?.[key]) ? data[key] : [data?.[key]];
    for (const item of values) {
      const url = typeof item === 'string' ? item : item?.url;
      if (typeof url === 'string' && url.trim()) urls.push(url.trim());
    }
  }
  return [...new Set(urls)];
}

export function replaceGenerationInputUrls(data, replacements) {
  const lookup = new Map(replacements.map(item => [item.from, item.to]));
  const result = { ...data };
  const replace = item => typeof item === 'string' ? lookup.get(item) || item
    : item?.url && lookup.has(item.url) ? { ...item, url: lookup.get(item.url) } : item;
  for (const key of ['inputAssets', 'imageUrl', 'image_url', 'inputImageUrl', 'input_image_url', 'inputVideoUrl', 'input_video_url', 'inputAudioUrl', 'input_audio_url']) {
    if (result[key] != null) result[key] = Array.isArray(result[key]) ? result[key].map(replace) : replace(result[key]);
  }
  return result;
}

export async function resolveGuestMediaInputs(data, fetchImpl = fetch) {
  const urls = generationInputUrls(data);
  if (!urls.length) return data;
  const response = await fetchImpl('/api/upload/guest-handoff', { method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'resolve', urls }) });
  const result = await response.json();
  if (!response.ok) throw Object.assign(new Error(result.error?.message || 'Reference images could not be prepared. Please upload them again.'), {
    code: result.error?.code || 'GUEST_MEDIA_HANDOFF_FAILED', status: response.status,
  });
  return replaceGenerationInputUrls(data, result.replacements || []);
}
